import { memo } from 'preact/compat'

type Props = {
  isOpen: boolean
  onClick: () => void
  imageUrl: string
}

const Handler = (props: Props) => (
  <div className="wf_floater wf_handler wf_reset" onClick={props.onClick}>
    <div className={`wf_handler_icon wf_handler_logo ${props.isOpen ? 'wf_open' : ''} wf_reset`}>
      {props.imageUrl ? <img className="wf_reset" src={props.imageUrl} /> : <Logo className="wf_reset" />}
    </div>
    <div className={`wf_handler_icon wf_handler_close ${props.isOpen ? 'wf_open' : ''} wf_reset`}>
      <Close className="wf_reset" />
    </div>
  </div>
)

const Logo = memo((props: { className: string }) => (
  <svg className={props.className} width="100%" height="100%" viewBox="0 0 60 60">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <g transform="translate(12.307692, 18.500000)">
          <g fill="#ffffff">
            <path d="M21.6939271,0.327777778 C21.6939271,0.327777778 20.5927126,0.327777778 17.9497976,0.327777778 C16.1878543,0.291358025 12.1133603,0.182098765 13.9487179,4.7345679 C17.0321188,12.3098765 23.8596491,29.2450617 23.8596491,29.2450617 C23.8596491,29.2450617 28.6682861,16.9716049 28.5581646,16.6802469 C24.4469636,6.77407407 21.6939271,0.327777778 21.6939271,0.327777778 Z M4.62510121,0.291358025 C2.86315789,0.291358025 -1.21133603,0.182098765 0.624021592,4.7345679 C3.7074224,12.3098765 10.4982456,29.2450617 10.4982456,29.2450617 C10.4982456,29.2450617 15.3068826,16.9716049 15.1967611,16.6802469 C11.1222672,6.77407407 8.36923077,0.327777778 8.36923077,0.327777778 C8.36923077,0.327777778 7.26801619,0.291358025 4.62510121,0.291358025 Z"></path>
          </g>
          <g transform="translate(25.327935, 0.000000)" fill="#2BC4B6">
            <polygon points="0 0.327777778 4.91875843 12.3462963 9.39703104 0.327777778"></polygon>
          </g>
        </g>
      </g>
    </g>
  </svg>
))

const Close = memo((props: { className: string }) => (
  <svg
    className={props.className}
    width="14"
    height="14"
    x="0px"
    y="0px"
    viewBox="0 0 1000 1000"
    enableBackground="new 0 0 1000 1000"
  >
    <g>
      <path
        fill="currentColor"
        d="M638.6,500l322.7-322.7c38.3-38.3,38.3-100.3,0-138.6C923,0.4,861,0.4,822.7,38.7L500,361.4L177.3,38.7C139,0.4,77,0.4,38.7,38.7C0.4,77,0.4,139,38.7,177.3L361.4,500L38.7,822.7C0.4,861,0.4,923,38.7,961.3C57.9,980.4,82.9,990,108,990s50.1-9.6,69.3-28.7L500,638.6l322.7,322.7c19.1,19.1,44.2,28.7,69.3,28.7c25.1,0,50.1-9.6,69.3-28.7c38.3-38.3,38.3-100.3,0-138.6L638.6,500z"
      />
    </g>
  </svg>
))

export default memo(Handler)
